import { buildAgreementsPayloadFromFilter } from '../../../agreements/utils/agreements-filter-payload.builder';
import { buildMaterialSummaryFilterFromTaskPaneRead } from '../../../material-summary/utils/build-material-summary-payload.util';
import { readMaterialSummaryTaskPaneFilterFromDom } from '../../../material-summary/utils/read-material-summary-task-pane-filter.util';
import { getInputValue } from '../../../shared/dom.util';
import { readAgreementsTaskPaneFilterFromDom } from '../../report-input/read-agreements-taskpane-filter.util';
import {
    REPORT_TARGET_AGREEMENTS_VALUE,
    REPORT_TARGET_MATERIAL_SUMMARY_VALUE,
} from '../../taskpane.constants';
import { ORG_CODE_INPUT_ID } from '../../utils/org-code-field.util';
import { stableFingerprintString } from './stable-json-fingerprint.util';

/**
 * Builds a session-stable fingerprint for the current DOM filter state + reporting target + org code.
 * Matches the normalized filter objects sent to the Activity Handler (same builders as fetch).
 */
export function buildTraceFetchFingerprintString(targetId: string): string | null {
    const orgCode = getInputValue(ORG_CODE_INPUT_ID).trim().toLowerCase();
    let filter: unknown;
    switch (targetId) {
        case REPORT_TARGET_AGREEMENTS_VALUE: {
            const domFilter = readAgreementsTaskPaneFilterFromDom();
            filter = buildAgreementsPayloadFromFilter(domFilter).data.filter;
            break;
        }
        case REPORT_TARGET_MATERIAL_SUMMARY_VALUE: {
            const read = readMaterialSummaryTaskPaneFilterFromDom();
            filter = buildMaterialSummaryFilterFromTaskPaneRead(read);
            break;
        }
        default:
            return null;
    }
    return stableFingerprintString({ targetId, orgCode, filter });
}
